export const SIDEBAR_COLLAPSED_KEY = 'ggb.sidebar-collapsed';
export function readSidebarCollapsed() {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1';
  } catch {
    return false;
  }
}
export function writeSidebarCollapsed(collapsed: boolean) {
  try {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, collapsed ? '1' : '0');
  } catch {
    /* The sidebar still collapses for this visit when storage is unavailable. */
  }
}
